module.exports = __webpack_public_path__ + "img/bonhomme-seul.9106ddf0.png";